import React, { useEffect } from "react";
import HomeMobileNavbar from "../components/HomeMobileNavbar";
import Navbar from "../components/Navbar";

const faqsData = [
  {
    id: "01",
    title: "Cancellations",
    items: [
      {
        q: "Orders can be cancelled within 24 hours from when they were placed.",
      },
      {
        q: "To cancel an order, go to Account > Orders > Cancel Order.",
      },
    ],
  },
  {
    id: "02",
    title: "Returns & Exchanges",
    items: [
      {
        q: "Requests must be raised within 7 days of delivery.",
      },
      {
        q: "Each order is eligible for a return or exchange only once, free of cost.",
      },
      {
        q: "Exchange is subject to stock availability. If your chosen fabric is unavailable, our team will contact you for an alternative.",
      },
      {
        q: "Products must be unworn, unused, and have all original tags and labels intact. Your exchange order will be processed and shipped only after the returned item reaches our warehouse and passes the quality check.",
      },
      {
        q: "We initiate a reverse pickup for most serviceable pincodes in India. If your pincode is not serviceable for reverse pickup, you must self-ship the product to our warehouse.",
      },
      {
        q: "To place a Return/Exchange Request, simply go to Account > Orders > Return/Exchange, then enter address and reason for return.",
      },
    ],
  },
  {
    id: "03",
    title: "Refunds",
    items: [
      {
        q: "Refunds are credited back to the original source of payment within 7 days of your order being recieved by us.",
      },
      {
        q: "Please allow 2-3 business days for the amount to reflect in your account.",
      },
    ],
  },
  {
    id: "04",
    title: "Damaged or Defective Items",
    items: [
      {
        q: "Please email us at our support email people@nufab.studio or Whatsapp us at +91 92445 01941 to report damage/defects with clear photos and details, within 48 hours of delivery.",
      },
      {
        q: "Our team will get back to you within 3-7 working days and refunds will be processed for defective or damaged orders.",
      },
      {
        q: "We sell handcrafted products. Slight variations in colour, print, or weave are signs of authenticity, not defects. Misprints and minor color differences from website images are not considered damage and are not eligible for 'Damaged Product' refunds.",
      },
    ],
  },
  {
    id: "05",
    title: "Contact Us",
    items: [
      {
        q: "Support Email: people@nufab.studio",
      },
      {
        q: "Phone: +91 9244501941",
      },
      {
        q: "Support Hours: Monday to Saturday, 11:00 AM – 7:00 PM IST",
      },
      {
        q: "The company holds the authority to make the final decision regarding Returns, Exchanges, Refunds and Cancellations in any case.",
      },
    ],
  },
];

const ReturnPage = () => {

  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  React.useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">Return/Exchange Policy</p>
      {faqsData.map((section, sectionIdx) => (
        <div
          key={section.id}
          // RESPONSIVE: Stack vertically on mobile, horizontal on desktop
          className="flex flex-col lg:flex-row gap-6 lg:gap-10 border-b border-black pt-10 pb-10 lg:pb-0"
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column Wrapper */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* RESPONSIVE: Scale font size and center title block on desktop */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Items List */}
            <div className="space-y-4 w-full">
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isLast = itemIdx === section.items.length - 1;

                return (
                  <div
                    key={key}
                    className={`${!isLast ? "border-b border-black" : ""} pb-4`}
                  >
                    <button
                      className="w-full flex justify-between items-start text-left cursor-default"
                    >
                      <span className="text-sm md:text-base text-black font-medium pr-0 md:pr-6 leading-relaxed">
                        {item.q}
                      </span>
                    </button>

                    {/* Hidden answer div to maintain structure if needed later */}
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out hidden`}>
                      <div className="overflow-hidden">
                        <p className="text-base leading-relaxed pr-10">
                          {/* {item.a} */}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default ReturnPage;